import $ from 'jquery';

$("[data-bg-src]").each(function () {
    var imgUrl = $(this).data("bg-src");
    $(this).css({
        "background-image": "url(" + imgUrl + ")"
    });
});

$("[data-scroll-to]").each(function () {
    $(this).click(function () {
        $("html, body").animate({
            scrollTop: 0
        }, "slow");
    });
});

window.onscroll = function () {

    var offset = 200;

    if (window.pageYOffset >= offset) {
        $('.menu-fixed').addClass('active');
    } else if ($(window).scrollTop() < offset) {
        $('.menu-fixed').removeClass('active');
    }

};